import React from "react";
import JobCategoryPieChart from "./JobCategoryPieChart";
import JobDoughnutChart from "./JobCategoryPieChart";

function PieChart() {
  return (
    <div>
      {/* <JobCategoryPieChart categories={categories} colors={colors} />; */}
      {/* <JobCategoryPieChart data={data} /> */}
      <JobDoughnutChart />
    </div>
  );
}

export default PieChart;
